module.exports = __webpack_public_path__ + "static/media/sih-gf.b9ed5d8e.jpg";